import { FC } from 'react'

import styles from './SpaceInfo.module.scss'

export const SpaceInfo: FC = () => {
	return (
		<ul className={styles.info}>
			<li className={styles.iten}>
				<h3 className={styles.title}>37</h3>
				<p className={styles.subtitle}>
					Объектов <br />в 9 городах России
				</p>
			</li>
			<li className={styles.iten}>
				<h3 className={styles.title}>500+</h3>
				<p className={styles.subtitle}>сотрудников</p>
			</li>
			<li className={styles.iten}>
				<h3 className={styles.title}>25</h3>
				<p className={styles.subtitle}>лет на рынке</p>
			</li>
		</ul>
	)
}
